/**
 * AudioPodcastForm - Form for adding RSS-based audio podcasts
 */
import { Rss, Plus, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

export const AudioPodcastForm = ({ 
  formData, 
  setFormData, 
  onSubmit, 
  onCancel, 
  adding 
}) => {
  return (
    <form onSubmit={onSubmit} className="bg-zinc-900 rounded-xl p-6 space-y-4 border border-white/10">
      <h3 className="text-white font-bold flex items-center gap-2">
        <Rss className="w-5 h-5 text-orange-500" />
        Add Audio Podcast from RSS
      </h3>
      
      <div>
        <label className="block text-zinc-400 text-sm mb-1">RSS Feed URL *</label>
        <input
          type="url"
          value={formData.rss_url}
          onChange={(e) => setFormData({ ...formData, rss_url: e.target.value })}
          placeholder="https://feeds.example.com/podcast.rss"
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          required
          data-testid="audio-rss-url"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Override Name (optional)</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Leave blank to use RSS title"
            className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          />
        </div>
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Category</label>
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          >
            <option value="Sports">Sports</option>
            <option value="News">News</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Analysis">Analysis</option>
            <option value="Interview">Interview</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">Override Description (optional)</label>
        <textarea
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Leave blank to use RSS description"
          rows={2}
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        />
      </div>

      <div className="flex gap-2 pt-2">
        <Button type="submit" disabled={adding} className="bg-orange-500 hover:bg-orange-600">
          {adding ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Plus className="w-4 h-4 mr-2" />}
          Add Podcast
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default AudioPodcastForm;
